import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    Box,
    Chip
} from '@mui/material';
import {
    Close as CloseIcon,
    ContentCopy as CopyIcon
} from '@mui/icons-material';
import CustomButton from '../../../components/buttons/CustomButton';
import { sanitizeHtml } from '../../../utils/sanitizeHtml';

const DocumentPreviewModal = ({ 
    open, 
    onClose, 
    template,
    onCopy 
}) => {
    if (!template) return null;

    const getTypeLabel = (type) => {
        switch(type) {
            case 'receipt': return 'Recibo';
            case 'default': 
            default: return 'Simples';
        }
    };

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(template.text);
            if (onCopy) {
                onCopy(template);
            }
        } catch {}
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 2,
                    maxHeight: '80vh'
                }
            }}
        >
            <DialogTitle sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                pb: 1
            }}>
                <Box>
                    <Typography variant="h6" component="div">
                        {template.tag || template.title || 'Documento'}
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                        <Chip
                            label={getTypeLabel(template.type)}
                            size="small"
                            color="primary"
                            variant="filled"
                        />
                    </Box>
                </Box>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={onClose}
                    aria-label="fechar"
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers sx={{ py: 3 }}>
                <Box sx={{ 
                    minHeight: '200px',
                    p: 2,
                    border: '1px solid',
                    borderColor: 'divider',
                    borderRadius: 1,
                    backgroundColor: 'background.paper'
                }}>
                    <div 
                        dangerouslySetInnerHTML={{ __html: sanitizeHtml(template.text) }}
                        style={{
                            lineHeight: 1.6,
                            fontSize: '14px',
                            color: '#333'
                        }}
                    />
                </Box>
            </DialogContent>

            <DialogActions sx={{ p: 2, gap: 1 }}>
                <CustomButton
                    style="secondary"
                    variant="outlined"
                    icon={<CopyIcon />}
                    label="Copiar Conteúdo"
                    onClick={handleCopy}
                />
                <CustomButton
                    style="primary"
                    variant="contained"
                    label="Fechar"
                    onClick={onClose}
                />
            </DialogActions>
        </Dialog>
    );
};

export default DocumentPreviewModal;